import React from 'react'

const TutorPage = () => {
  return (
    <div>Tutor</div>
  )
}

export default TutorPage